import { Modal, Skeleton } from "antd";
import { useHospedes } from "../hooks/useHospedes";

import { ContainerHospedes, TextHospedes, TitleHospedes } from "../styles";
import { convertIdade } from "../utils/idadeUtils";
import { useEffect, useState } from "react";
import { formatarData } from "../../../components/Globais";
import { useError } from "../../../uteis/mensagens/useError";

export default function ModalHospedes({
  isModalOpen,
  handleFechar,
  reservaId,
}: any) {
  const { hospedes, loading, error } = useHospedes(reservaId, isModalOpen);
  const { showError, contextHolder } = useError();

  const [errorDisplayed, setErrorDisplayed] = useState(false); // Estado para controlar se o erro já foi exibido

  //  useEffect para lidar com o erro
  useEffect(() => {
    if (isModalOpen && error && !errorDisplayed) {
      // Verifica se o erro já foi exibido
      showError(error);
      setErrorDisplayed(true); // Marca que o erro foi exibido
    }

    // Limpa o estado de erro quando o modal é fechado
    if (!isModalOpen) {
      setErrorDisplayed(false); // Reseta o controle de erro
    }
  }, [isModalOpen, error, showError, errorDisplayed]);

  return (
    <>
      {/* //Exibe a mensagem de erro */}
      {contextHolder}
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        {loading && <Skeleton active />}
        {!loading &&
          !error &&
          hospedes.map((hospede, index) => (
            <ContainerHospedes key={hospede.idUsuario}>
              <TitleHospedes>Hóspede {index + 1}</TitleHospedes>
              <TextHospedes>
                <span style={{ fontWeight: "bold" }}>Nome completo: </span>
                {`${hospede.Usuario.nome} ${
                  hospede.Usuario.sobrenome ? hospede.Usuario.sobrenome : ""
                }`}
              </TextHospedes>
              <TextHospedes>
                <span style={{ fontWeight: "bold" }}>CPF: </span>
                {hospede.Usuario.cpf}
              </TextHospedes>
              <TextHospedes>
                <span style={{ fontWeight: "bold" }}>Data de Nascimento: </span>
                {hospede.Usuario.dataNascimento
                  ? formatarData(hospede.Usuario.dataNascimento.toString())
                  : "Data não disponível ou inválida"}
              </TextHospedes>
              <TextHospedes>
                <span style={{ fontWeight: "bold" }}>Idade: </span>
                {convertIdade(hospede.Usuario.dataNascimento)}
              </TextHospedes>
            </ContainerHospedes>
          ))}
      </Modal>
    </>
  );
}
